document.addEventListener('click', function (e) {
  const button = e.target.closest('.ajax-add-to-cart');
  if (!button) return;
  e.preventDefault();

  // Evitar clics repetidos hasta que termine la petición
  if (button.dataset.loading === 'true') return;
  button.dataset.loading = 'true';

  const variantId = button.dataset.variantId;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(response => {
    if (!response.ok) throw new Error();
    return response.json();
  })
  .then(() => {
    button.innerText = '✓ Agregado';
    button.style.backgroundColor = '#1db954';
    setTimeout(() => {
      button.innerText = 'Agregar al carrito';
      button.style.backgroundColor = '#000';
      button.dataset.loading = 'false';
    }, 1500);
  })
  .catch(() => {
    alert('No se pudo agregar al carrito. Intenta de nuevo.');
    button.dataset.loading = 'false';
  });
});